goog.provide("shadow.js.shim.module$react_swipeable_views$default");
shadow.js.shim.module$react_swipeable_views$default = shadow.js.require(633, {})["default"];
